import React from 'react';
import { bonuses } from '../data/content';
import { Eyebrow } from './ui/Eyebrow';
export function Bonuses() {
  return <section className="w-full bg-beige" data-id="element-25" data-mp="pio8klwnr28j">
      <div className="mx-auto max-w-content px-6 py-20" data-id="element-26" data-mp="plsj010puu7n">
        <div className="text-center" data-id="element-27" data-mp="aua9mm2d3xx9">
          <Eyebrow data-id="element-28" data-mp="at8uo6i86ra9">Dodatki w cenie</Eyebrow>
          <h2 className="mt-4 font-display text-[24px] font-bold leading-tight text-ink sm:text-[27px]" data-id="element-29" data-mp="ftejlex41zon">
            5 Ekskluzywnych Dodatków
          </h2>
          <p className="mt-3 text-[12px] text-muted" data-id="element-30" data-mp="1wrhyyu7qlce">
            Wszystkie <span className="font-semibold text-ink" data-id="element-31" data-mp="5xjtjyqk52bu">dodatki</span>{' '}
            otrzymujesz razem z pakietem{' '}
            <span className="font-semibold text-ink" data-id="element-32" data-mp="3o3pso0957wwe">PLASTYKA GOTOWA™</span>.
          </p>
        </div>

        <ul className="mx-auto mt-9 max-w-xl space-y-3" data-id="element-33" data-mp="3t2snyszbmor6">
          {bonuses.map(bonus => <li key={bonus.title} className="flex items-center gap-4 rounded-xl border border-ink/10 bg-white px-4 py-4" data-id="element-34" data-mp="1m85l9ku25ojq">
              <div className="relative shrink-0" data-id="element-35" data-mp="3iden48rps86g">
                <img src={bonus.image} alt={`${bonus.title} — ${bonus.description}`} className="h-16 w-16 rounded-md object-cover shadow-[0_6px_14px_-8px_rgba(36,28,24,0.7)]" width={320} height={320} data-id="element-36" data-mp="3dfd2hjen40sv" />
                <span className="absolute -left-1.5 -top-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-coral text-[8px] font-bold text-white" data-id="element-37" data-mp="2zfanq61mpnhu">
                  {bonus.number}
                </span>
              </div>

              <div className="min-w-0" data-id="element-38" data-mp="38hbhuu1kftfa">
                <h3 className="font-display text-[12px] font-bold uppercase tracking-wide text-ink" data-id="element-39" data-mp="38e5ubj8l4zlo">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-[11px] leading-snug text-muted" data-id="element-40" data-mp="np004uox2gap">
                  {bonus.description}
                </p>
                <p className="mt-1.5 text-[9px] font-semibold uppercase tracking-[0.14em] text-coral" data-id="element-41" data-mp="iqor2m6g49tj">
                  {bonus.value}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}